import BaseApi from './base.api'

class AccountingApi extends BaseApi {
  financialCentersUrl = 'financial-centers/'
  tradeAccountsUrl = 'trade-accounts/'
  tradeAccountFinancialCenterAssociationsUrl = 'trade-account-financial-center-associations/'

  constructor() {
    super('accounting/')
  }

  getFinancialCentersAsync = (params) => this.get(this.financialCentersUrl, params)
  getTradeAccountsAsync = (params) => this.get(this.tradeAccountsUrl, params)
  getTradeAccountFinancialCenterAssociationsAsync = (params) => this.get(this.tradeAccountFinancialCenterAssociationsUrl, params)
}
export const accountingApi = new AccountingApi()
